import type { TranslationKey } from "providers/I18nProvider";

export const CORRECTION_ATTRIBUTE_LABEL_MAP: Record<string, TranslationKey> = {
  name: "apps.admin.pages.taskDetails.correction.employeeDetails.name",
  firstName:
    "apps.admin.pages.taskDetails.correction.employeeDetails.firstName",
  lastName: "apps.admin.pages.taskDetails.correction.employeeDetails.lastName",
  dateOfBirth:
    "apps.admin.pages.taskDetails.correction.employeeDetails.dateOfBirth",
  phoneNumber:
    "apps.admin.pages.taskDetails.correction.employeeDetails.phoneNumber",
  phone: "apps.admin.pages.taskDetails.correction.employeeDetails.phoneNumber",
  address: "apps.admin.pages.taskDetails.correction.employeeDetails.address",
  passportNumber:
    "apps.admin.pages.taskDetails.correction.employeeDetails.passportNumber",
  nationalId:
    "apps.admin.pages.taskDetails.correction.employeeDetails.emiratesId",
  startDate:
    "apps.admin.pages.taskDetails.correction.employeeDetails.startDate",
  endDate: "apps.admin.pages.taskDetails.correction.employeeDetails.endDate",
  basicSalary:
    "apps.admin.pages.taskDetails.correction.employeeDetails.basicSalary",
  fullSalary:
    "apps.admin.pages.taskDetails.correction.employeeDetails.fullSalary",
  iban: "apps.admin.pages.taskDetails.correction.employeeDetails.iban",
  employeeID:
    "apps.admin.pages.taskDetails.correction.employeeDetails.employeeName",
};

export const MOHRE_EMPLOYEE_ATTRIBUTES = new Set([
  "name",
  "firstName",
  "lastName",
  "nationalId",
  "passportNumber",
  "address",
  "startDate",
  "endDate",
  "nationality",
  "gender",
  "dateOfBirth",
  "basicSalary",
  "fullSalary",
  "workPermitNumber",
  "employerId",
  "unifiedNumber",
  "arabicName",
]);
